import { render, staticRenderFns } from "./HighlightFormSection.vue?vue&type=template&id=53a46824&scoped=true"
import script from "./HighlightFormSection.vue?vue&type=script&lang=js"
export * from "./HighlightFormSection.vue?vue&type=script&lang=js"
import style0 from "./HighlightFormSection.vue?vue&type=style&index=0&id=53a46824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a46824",
  null
  
)

export default component.exports